import React, { useEffect, useRef, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { Link, useLocation } from 'react-router-dom';
import menuItems from './sidebarMenu.json';
import sidebarManagementMenu from './sidebarManagementMenu.json';
import CreateLeadModal from "../../modals/CreateLeadModal";
import { usePermissions } from '../../../hooks/usePermissions';
import { Permission } from '../../../utils/rolePermissions';

const Sidebar = ({ isSidebarClose, isSidebarOpen }) => {
  const location = useLocation()
  const path = location.pathname
  const { hasPermission, hasAnyPermission } = usePermissions()

  const [dropdownState, setDropdownState] = useState({
    sidebar: false,
  });

  const dropdownRefs = useRef({
    sidebar: null,
  });
  const handleOpen = (section) => {
    setDropdownState((prev) => ({
      ...prev,
      [section]: !prev[section], // Toggle the open state for the clicked dropdown
    }));
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      let shouldClose = true;
      Object.values(dropdownRefs.current).forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          shouldClose = false;
        }
      });
      if (shouldClose) {
        setDropdownState({
          sidebar: false,
        });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const [openMenu, setOpenMenu] = useState(null);
  const handleToggle = (collapseId) => {
    setOpenMenu((prevOpenMenu) => (prevOpenMenu === collapseId ? null : collapseId));

  };

  const [openMenu1, setOpenMenu1] = useState(false)
  const handleOpenMenu1 = () => setOpenMenu1(!openMenu1)

  const [openMenu2, setOpenMenu2] = useState(false)
  const handleOpenMenu2 = () => setOpenMenu2(!openMenu2)

  const [openMenu3, setOpenMenu3] = useState(false)
  const handleOpenMenu3 = () => setOpenMenu3(!openMenu3)

  const [auth, setAuth] = useState(false)
  const handleAuth = () => setAuth(!auth)

  const renderIcon = (iconSvg) => {
    return { __html: iconSvg };
  };

  // Helper function to check if user has required permissions for a menu item
  const hasMenuPermission = (item) => {
    if (!item.requiredPermissions || item.requiredPermissions.length === 0) {
      return true; // No permissions required, show the item
    }

    const permissions = item.requiredPermissions.map(perm => Permission[perm]).filter(Boolean);
    
    if (item.requireAny) {
      // User needs any of the specified permissions
      return hasAnyPermission(permissions);
    } else {
      // User needs all of the specified permissions (default behavior)
      return permissions.every(permission => hasPermission(permission));
    }
  };

  // Filter menu items based on user permissions
  const filterMenuItems = (items) => {
    return items.filter(item => {
      // Check if the main menu item should be visible
      if (!hasMenuPermission(item)) {
        return false;
      }

      // If it has submenus, filter them too
      if (item.subMenu && item.subMenu.length > 0) {
        const filteredSubMenu = item.subMenu.filter(hasMenuPermission);
        
        // If no submenu items are visible, hide the parent menu
        if (filteredSubMenu.length === 0) {
          return false;
        }
        
        // Update the item with filtered submenu
        item.filteredSubMenu = filteredSubMenu;
      }

      return true;
    });
  };

  // Get filtered menu items
  const filteredMenuItems = filterMenuItems([...menuItems]);
  const filteredManagementMenu = filterMenuItems([...sidebarManagementMenu]);


  return (

    <>
      <div className={`sidebar p-2 py-md-3 ${isSidebarClose ? 'sidebar-mini' : isSidebarOpen ? 'open' : ''}`}>
        <div className="container-fluid">
          <div className="title-text d-flex align-items-center mb-4 mt-1">
            <Link to="/" className="sidebar-logo">
              <h4 className="sidebar-title mb-0 fw-bold text-primary">Tirhelo Portal</h4>
            </Link>
          </div>

          <div className="main-menu flex-grow-1">
            <ul className="menu-list">
              <li className="divider py-2 lh-sm"><span className="small">MAIN</span><br/> <small className="text-muted">Main
                loan operations </small></li>

              {
                filteredMenuItems
                    .map((item, index) => {
                      const subMenuToRender = item.filteredSubMenu || item.subMenu;
                      const isActive = subMenuToRender?.some((subItem) => subItem.path === path);
                      const isOpen = openMenu === item.collapseId || isActive;
                      return (
                          <li key={index} className="collapsed">
                            <Link
                                className={subMenuToRender?.some((subItem) => subItem.path === path) ? "m-link collapsed" : "m-link"}
                                data-bs-target={`#${item.collapseId}`}
                                aria-expanded={item.path ? item.path == path : isOpen}
                                onClick={() => handleToggle(item.collapseId)}
                                to={item.path}
                            >
                              <div dangerouslySetInnerHTML={renderIcon(item.icon)}/>
                              <span className="ms-2">{item.title}</span>
                              {subMenuToRender && <span
                                  className="arrow fa fa-angle-right ms-auto text-end"

                              ></span>}
                            </Link>
                            <ul className={isOpen ? "sub-menu collapse show" : "sub-menu collapse"}
                                id={item.collapseId}>
                              {subMenuToRender?.map((subItem, subIndex) => {
                                return (
                                    <li key={subIndex} className="collapsed">
                                      <Link
                                          className={path === subItem.path ? "ms-link active" : "ms-link"}
                                          to={subItem.path}
                                          data-bs-toggle={subItem.subMenu ? "collapse" : ""}
                                          data-bs-target={subItem.subMenu ? `#menu-level-${subIndex}` : ""}
                                      >
                                        {subItem.title}
                                        {subItem.subMenu &&
                                            <span className="arrow fa fa-angle-right ms-auto text-end"></span>}
                                      </Link>
                                    </li>
                                )
                              })}
                            </ul>
                          </li>
                      );
                    })}
            </ul>

            <ul className="menu-list">
              <li className="divider py-2 lh-sm"><span className="small">MANAGEMENT</span><br/> <small
                  className="text-muted">Client management</small></li>

              {
                filteredManagementMenu
                    .map((item, index) => {
                      const subMenuToRender = item.filteredSubMenu || item.subMenu;
                      const isActive = subMenuToRender?.some((subItem) => subItem.path === path);
                      const isOpen = openMenu === item.collapseId || isActive;
                      return (
                          <li key={index} className="collapsed">
                            <Link
                                className={subMenuToRender?.some((subItem) => subItem.path === path) ? "m-link collapsed" : "m-link"}
                                data-bs-target={`#${item.collapseId}`}
                                aria-expanded={item.path ? item.path == path : isOpen}
                                onClick={() => handleToggle(item.collapseId)}
                                to={item.path}
                            >
                              <div dangerouslySetInnerHTML={renderIcon(item.icon)}/>
                              <span className="ms-2">{item.title}</span>
                              {subMenuToRender && <span
                                  className="arrow fa fa-angle-right ms-auto text-end"

                              ></span>}
                            </Link>
                            <ul className={isOpen ? "sub-menu collapse show" : "sub-menu collapse"}
                                id={item.collapseId}>
                              {subMenuToRender?.map((subItem, subIndex) => {
                                return (
                                    <li key={subIndex} className="collapsed">
                                      <Link
                                          className={path === subItem.path ? "ms-link active" : "ms-link"}
                                          to={subItem.path}
                                          data-bs-toggle={subItem.subMenu ? "collapse" : ""}
                                          data-bs-target={subItem.subMenu ? `#menu-level-${subIndex}` : ""}
                                      >
                                        {subItem.title}
                                        {subItem.subMenu &&
                                            <span className="arrow fa fa-angle-right ms-auto text-end"></span>}
                                      </Link>
                                    </li>
                                )
                              })}
                            </ul>
                          </li>
                      );
                    })}
            </ul>
          </div>
        </div>
      </div>
    </>

  )
}

export default Sidebar
